export const postCreateOrder = "/create-order";
export const getOrder = "/orders/:date";
export const getOrdersDate = "/orders-date";

export const getUsers = "/users";
export const getUserById = "/user/:id";

export const getCustomers = "/customers";
export const getCustomerById = "/customer/:id";
export const getCustomerAccount = "/customer-account";
export const getCustomerTrayAccount = "/customer-tray-account"
// Department
export const getDepartments = "/departments";
export const getDepartmentById = "/departments/:id";
// 
export const getHR = "/hr";
export const getHRById = "/hr/:id";

export const getProducts = "/products";
export const getProductById = "/product/:id";

export const postPayment = "/payment";
export const postPaymentUpdate = "/payment-data";
export const getArrearAmount = "/customer-arrearAmount/:id";


export const postTrayUpdate = "/tray-data";
export const getTrayStore = "/tray-store";
export const getOrderItems = "/order-items/:date/:id";
export const getOrderDetailPage = "/order-detail-page/:date/:id";
export const getArrearsDetails = "/customer-arrearAmount";
export const getOrderStatus = "/ordersByStatus/:date";
export const getCreatedOrderArray = "/compareOrder/:date/:id";

export const getAllCustomerReports = "/all-customers-orders";
export const getCustomerReport = "/customer-orders";
export const getMonthlyDailyReports = "/monthly-order";

export const postCreateProductionOrder = "/create-production-order";
export const postProductionOrder = "/production-order";
export const postNewCreateOrder = "/creat-new-order";
export const postProductionStatus = "/change-production-status";
export const postMissingOrder = "/missing-items";
export const getModification = "/modification-items/:date/:id";
export const postCreateDeliverOrder = "/create-delivered-order";
export const postNewOrderPayment = "/new-order-payment";

export const getInvioceDoc = "/doc-for-invoice/:date/:id";

export const getOrderTypesTotalPrice = "/ordersTypesPrice/:startDate/:endDate";
export const getOrderSub_TypeTotalPrice =
  "/ordersTypesPrice/:startDate/:endDate/:type";

export const addInventory = "/inventory/add";
export const subtractInventory = "/inventory/subtract";
export const getInventory = "/inventory";
export const getInventoryByDate ="/inventory/:date"

export const addRawMetarial = "/rawMetarial/add";
export const subtractRawMetarial = "/rawMetarial/subtract";
export const getRawMetarial = "/rawMetarial";
export const getRawMetarialByDate ="/rawMetarial/:date"

export const getOrderQuantity = "/created-order-orderQuantity/:date/:type";
export const getmodificationQuantity ="/modification-orderQuantity/:date/:type";
export const getTotalReturn = "/totalReturn/:date";

export const getRawMaterial = "/raw-material";
export const getItems = "/items";
export const getRecipe = "/recipe";
export const getSupplier = "/supplier";
export const postSupplierBill = "/supplier-bill";

export const postOrderPurchase = "/postorderpurchase";
export const getPurchaseOrdersDate = "/puchaseOrders-date";
export const getPurchaseOrderStatus = "/purchaseOrderStatus/:date";

//Account Setting
export const updateAcountSetting = "/account-setting";
export const getAcountSetting = "/get-account-setting";

 
//Accounts

export const BaseLevel = "/levels";

export const Level1 = `${BaseLevel}/:level1`;

export const Level2 = `${BaseLevel}/:level1/:level2`;

export const Level3 = `${BaseLevel}/:level1/:level2/:level3`;

export const voucherIndex = `/voucherIndex/:month/:type`;

export const createVoucher = "/vouchers/:type";
export const createAccountVoucher = "/accounts-vouchers/:type";
export const voucherInrange =
  "/vouchers/:level1/:level2/:level3/:startDate/:endDate";

export const specificVoucher = "/voucher/:month/:type/:number";

export const voucher = `/vouchers/:level1/:level2/:level3`;

export const voucherByDate = `/vouchers/:level1/:level2/:level3/:date`;

export const voucherUpdate = `/vouchers/:type/:index`;

export const voucherDelete = `/vouchers/:type/:index`;

//For Complaints

export const getComplaints = '/complaints';
export const saveComplaints = '/saveComplaints';
export const updateComplaints = '/deleteComplaints/:id';

//For Complaints

export const getTask = '/task';
export const saveTask = '/saveTask';
export const updateTask = '/updateTask/:id';
export const saveMessage = 'task/:id';
export const getMessage = 'getTask/:id';
